<script>
import CMSEditCard from "@/views/components/cms/CMSEditCard.vue";

export default {
  name: "EinarbeitungEdit",
  components: {CMSEditCard},
}
</script>

<template>
  <CMSEditCard></CMSEditCard>
</template>

<style scoped>

</style>
